import { IonCard, IonCardContent } from '@ionic/react';
import { Tab, Tabs } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { NavLink, useLocation, useParams } from 'react-router-dom';
import { CompetitionDTO } from '../../models/common/CompetitionDTO';
import { EventType } from '../../models/EventType';
import { RootState } from '../../models/RootState';
import { SelectedObj } from '../../models/ExchangeSportsState';
import { getSportLangKeyByName } from '../../util/localizationUtil';
import {
  fetchCompetitions,
  getCompetitionsByEventType,
  setCompetition,
  fetchEventsByCompetition,
} from '../../store';
import './ExchCompetitionsMenu.scss';
import { BBL_MEN, PSL_CUP } from '../../constants/IPLEvent';
import { EXCH_SPORTS_MAP } from '../../constants/ExchangeEventTypes';

type options = [{ name: string; value: string }];

type StoreProps = {
  allowedConfig: number;
  eventTypes: EventType[];
  competitions: CompetitionDTO[];
  selectedEventType: SelectedObj;
  selectedCompetition: SelectedObj;
  fetchCompetitions: (eventTypeId: string) => void;
  setCompetition: (competition: SelectedObj) => void;
  langData:any;
  fetchEventsByCompetition: (
    eventTypeId: string,
    competitionId: string

  ) => void;
};

const CompetitionsMenu: React.FC<StoreProps> = (props) => {
  const {
    allowedConfig,
    eventTypes,
    competitions,
    selectedEventType,
    selectedCompetition,
    fetchCompetitions,
    setCompetition,
    fetchEventsByCompetition,
    langData,
  } = props;
  const [tabValue, setTabValue] = useState<number>(0);
  const [subTabValue, setSubTabValue] = useState<number>(0);

  const pathParams = useParams();
  const competition = pathParams['competition'];
  const location = useLocation();

  const handleTabChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setTabValue(newValue);
  };

  const handleSubTabChange = (
    event: React.ChangeEvent<{}>,
    newValue: number
  ) => {
    setSubTabValue(newValue);
  };

  const handleCompetitionChange = (c: CompetitionDTO) => {
    setCompetition({ id: c.id, name: c.name, slug: c.slug });
    fetchEventsByCompetition(selectedEventType.id, c.id);
  };

  useEffect(() => {
    if (!location.pathname.startsWith('/exchange_sports/inplay')) {
      if (!competitions) {
        fetchCompetitions(selectedEventType.id);
      } else {
        if (competition && selectedCompetition.slug! === competition) {
          for (let i = 0; i < competitions.length; i += 1) {
            if (competitions[i].slug === competition && i !== tabValue) {
              setTabValue(i);
              handleCompetitionChange(competitions[i]);
              break;
            }
          }
        }
      }
    }
  }, [competitions, selectedCompetition]);

  useEffect(() => {
    if (!competition) {
      setCompetition({ id: '', name: '', slug: '' });
    }
  }, []);

  return (
    <div className="competitions-menu">
      <IonCard className="competitions-menu-card web-view">
        <IonCardContent className="competitions-menu-card-content">
          <Tabs
            orientation="vertical"
            variant="scrollable"
            value={tabValue}
            onChange={handleTabChange}
            aria-label="EventsTypes Menu"
            className="eventTypes-menu-tabs"
            scrollButtons="off"
          >
            <NavLink
              className="eventTypes-menu-nav-link"
              to="/exchange_sports/inplay"
            >
              <Tab
                className="eventTypes-menu-tab"
                label={langData?.['in_play']}
                value={11010010}
              />
            </NavLink>
            {/* <NavLink
              className="eventTypes-menu-nav-link"
              to={`/exchange_sports/cricket/bbl-womens/winner/${btoa(
                PSL_CUP.routeHash
              )}`}
              onClick={() => {
                setCompetition({ id: '', name: '', slug: '' });
              }}
            >
              <Tab
                className="eventTypes-menu-tab"
                label="PSL WINNER"
                value="100101001"
              />
            </NavLink> */}
            {eventTypes.map((et, eId) =>
              (allowedConfig & Number(EXCH_SPORTS_MAP[et.slug])) !== 0 ? (
                <div
                  key={eId}
                  style={{ display: 'flex', flexDirection: 'column' }}
                >
                  <NavLink
                    className="eventTypes-menu-nav-link"
                    key={et.slug + '-link'}
                    to={`/exchange_sports/${et.slug}`}
                    onClick={() => {
                      fetchCompetitions(et.id);
                      setCompetition({ id: '', name: '', slug: '' });
                    }}
                  >
                    <Tab
                      className="eventTypes-menu-tab"
                      label= {langData?.[`${getSportLangKeyByName(et.name)}`]}
                      value={eId}
                      key={et.slug + '-tab'}
                    />
                  </NavLink>

                  <div className="eventTypes-menu-tab-divider"></div>
                  {et.slug === selectedEventType.slug ? (
                    competitions ? (
                      competitions.length > 0 ? (
                        <Tabs
                          orientation="vertical"
                          variant="scrollable"
                          value={subTabValue}
                          onChange={handleSubTabChange}
                          aria-label="Competitions Menu"
                          className="competitions-menu-tabs"
                          scrollButtons="off"
                        >
                          {competitions.map((c, idx) => (
                            <NavLink
                              className="competitions-menu-nav-link"
                              key={c.slug + '-link'}
                              onClick={() => handleCompetitionChange(c)}
                              to={`/exchange_sports/${selectedEventType.slug}/${c.slug}`}
                            >
                              <Tab
                                className="competitions-menu-tab"
                                label={c.name}
                                value={idx}
                                key={c.slug + '-tab'}
                              />
                            </NavLink>
                          ))}
                        </Tabs>
                      ) : (
                        <div className="competitions-menu-msg-text">
                          No Competitons
                        </div>
                      )
                    ) : null
                  ) : null}
                </div>
              ) : null
            )}

            {/* <NavLink
              className="eventTypes-menu-nav-link"
              to="/exchange_sports/binary"
            >
              <Tab
                className="eventTypes-menu-tab"
                label="Binary"
                value={11010011}
              />
            </NavLink> */}
          </Tabs>
        </IonCardContent>
      </IonCard>
    </div>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    eventTypes: state.exchangeSports.eventTypes,
    competitions: getCompetitionsByEventType(
      state.exchangeSports.competitions,
      state.exchangeSports.selectedEventType.id
    ),
    selectedEventType: state.exchangeSports.selectedEventType,
    selectedCompetition: state.exchangeSports.selectedCompetition,
    allowedConfig: state.common.allowedConfig,
    langData:state.common.langData
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    fetchCompetitions: (eventTypeId: string) =>
      dispatch(fetchCompetitions(eventTypeId)),
    setCompetition: (competition: SelectedObj) =>
      dispatch(setCompetition(competition)),
    fetchEventsByCompetition: (eventTypeId: string, competitionId: string) =>
      dispatch(fetchEventsByCompetition(eventTypeId, competitionId, [])),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CompetitionsMenu);
